module.exports = "/img/side_banner.png?02f554f4955e9d7767f9a9c098b83000";